<template>
    <div class="tabBody">
        <el-dialog title="导入失败条目" :modal="false" :visible.sync="importErrorDialogVisible" v-dialogDrag :show-close="true" :close-on-press-escape="false" :before-close="handleClose">
            <el-table :data="erroritems" height="500px" ref="multipleTable" :header-cell-style="{background:'rgba(49,130,222,0.1)'}" border>
                <el-table-column align='center' label="淤地坝编码" prop="code"></el-table-column>
                <el-table-column align='center' label="失败原因" prop="reason"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="handleClose()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  export default {
    props: ['errordatas'],
    data() {
      return {
        importErrorDialogVisible: true,
        tableHeight: window.innerHeight - 180,
        erroritems: null  
      };
    },
    mounted() {
      this.erroritems = this.errordatas;
    },
    created() {},
    components: {},
    methods: {
        handleClose(){
            this.erroritems=null;
            this.importErrorDialogVisible=false;
            this.$emit("yjdcimporterrorcancel");
        }
    }
  };
</script>

<style scoped="scoped">
.el-dialog {
    width: 1400px;
  }
.el-dialog__body {
    max-height: 600px;
    overflow: auto;
}
.el-form-item__error {
    padding-top: 0;
}
</style>